<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="eight wide column">
            <Breadcrumb>
              <a class="section" v-go-back="'plans'">Planos</a>
              <i class="right chevron icon divider"></i>
              <div class="active section">{{ sectionName }}</div>
            </Breadcrumb>
          </div>
          <div v-show="persisted" class="eight wide right aligned column">
            <div class="actions">
              <a
                class="section"
                :href="$router.resolve({ name: 'newPlan' }).href"
              >
                <i class="plus icon"></i>Novo Plano
              </a>
              <a @click.prevent="openHistory"
                ><i class="history icon"></i>Histórico</a
              >
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <HistoryModal ref="history" resource="Plan" :item_id="form.id" />
      <form :class="['ui small', { error: anyError }, 'form']">
        <div class="ui padded grid">
          <div v-show="loading" class="ui active inverted dimmer">
            <div class="ui text loader">Carregando...</div>
          </div>
          <div class="row">
            <div class="eight wide column">
              <div
                :class="[{ error: errors.enable }, 'field']"
                :data-content="errorsTo('enable')"
              >
                <div class="ui toggle checkbox">
                  <input
                    type="checkbox"
                    id="plan-form-enable"
                    name="enable"
                    v-model="form.enable"
                  />
                  <label for="plan-form-enable">Plano ativo?</label>
                </div>
              </div>
              <br />
              <div
                :class="['required', { error: errors.description }, 'field']"
                :data-content="errorsTo('description')"
              >
                <label for="plan-form-description">Descrição</label>
                <input
                  type="text"
                  autofocus
                  id="plan-form-description"
                  name="name"
                  v-model="form.description"
                />
              </div>
              <div
                :class="['six wide', { error: errors.card_color }, 'field']"
                :data-content="errorsTo('payment_method')"
              >
                <label for="plan-form-card-color">Cor do cartão</label>
                <select
                  id="plan-form-card-color"
                  name="card_color"
                  v-model="form.card_color"
                >
                  <option :value="null"></option>
                  <option
                    v-for="(cardColor, index) in cardColors"
                    :key="index"
                    :value="cardColor.value"
                  >
                    {{ cardColor.description }}
                  </option>
                </select>
              </div>
              <div
                :class="[{ error: errors.obs }, 'field']"
                :data-content="errorsTo('obs')"
              >
                <label for="plan-form-obs">Observações:</label>
                <textarea
                  id="plan-form-obs"
                  name="obs"
                  v-model="form.obs"
                ></textarea>
              </div>
              <div class="fields">
                <div
                  :class="[
                    'four wide',
                    { error: errors.number_of_members },
                    'field'
                  ]"
                  :data-content="errorsTo('number_of_members')"
                >
                  <label for="plan-form-number-of-members"
                    >Número de membros</label
                  >
                  <input
                    type="text"
                    v-model="form.number_of_members"
                    id="plan-form-number-of-members"
                    name="number_of_members"
                  />
                </div>
                <div
                  :class="[
                    'four wide',
                    { error: errors.monthly_value },
                    'field'
                  ]"
                  :data-content="errorsTo('monthly_value')"
                >
                  <label for="plan-form-monthly-value">Valor mensalidade</label>
                  <money
                    v-model="form.monthly_value"
                    id="plan-form-monthly-value"
                  ></money>
                </div>
                <div
                  :class="[
                    'four wide',
                    { error: errors.membership_fee },
                    'field'
                  ]"
                  :data-content="errorsTo('membership_fee')"
                >
                  <label for="plan-form-membership-fee">Taxa de adesão</label>
                  <money
                    v-model="form.membership_fee"
                    id="plan-form-membership-fee"
                  ></money>
                </div>
                <div
                  v-if="$allows('procedure_authorizations')"
                  :class="[
                    'four wide',
                    { error: errors.monthly_value },
                    'field'
                  ]"
                  :data-content="errorsTo('monthly_balance')"
                >
                  <label for="plan-form-monthly-balance"> Saldo mensal </label>
                  <money
                    v-model="form.monthly_balance"
                    id="plan-form-monthly-balance"
                  ></money>
                </div>
              </div>
              <div class="field">
                <label for="plan-form-payment_methods">
                  Métodos de Pagamento
                </label>
                <select
                  id="plan-form-payment-methods"
                  class="ui fluid search dropdown"
                  multiple=""
                  v-model="form.payment_methods"
                >
                  <option
                    v-for="(payment_method, index) in paymentMethods"
                    :key="index"
                    :value="payment_method.name"
                  >
                    {{ payment_method.description }}
                  </option>
                </select>
              </div>
            </div>
            <div class="eight wide column">
              <h4 class="ui dividing header">Benefícios</h4>
              <div
                v-for="(benefit, index) in benefits"
                :key="index"
                class="ui fields"
              >
                <div class="ten wide field">
                  <label for="">Serviço</label>
                  <select name="service" v-model="benefit.service_id">
                    <option :value="null"></option>
                    <option
                      v-for="(service, serviceIndex) in services"
                      :key="serviceIndex"
                      :value="service.id"
                    >
                      {{ service.description }}
                    </option>
                  </select>
                </div>
                <div class="six wide field">
                  <label for="">Limite</label>
                  <input type="text" v-model="benefit.limit" name="limit" />
                </div>
                <div class="remove field">
                  <a
                    class="delete"
                    title="Remover"
                    @click.prevent="removeBenefit(index)"
                    ><i class="trash icon"></i
                  ></a>
                </div>
              </div>
              <a @click.prevent="addBenefit"
                ><i class="plus icon"></i> Adicionar Benefício</a
              >
            </div>
          </div>
          <!-- row -->
          <div class="row">
            <div class="sixteen wide column">
              <div class="ui divider"></div>
              <div class="field">
                <button
                  @click="save"
                  type="button"
                  name="save"
                  class="ui submit blue button"
                >
                  <i class="save icon"></i>Salvar
                </button>
                <a v-show="persisted" class="delete" @click.prevent="remove"
                  ><i class="trash icon"></i>Remover Plano</a
                >
              </div>
            </div>
          </div>
        </div>
        <!-- grid -->
      </form>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
import HistoryModal from '@/components/history_modal';
import CardColor from '@/enumerations/card_color_enum';
import { mapGetters } from 'vuex';

export default {
  name: 'PlanForm',
  components: { Breadcrumb, PageLayout, HistoryModal },

  data() {
    return {
      loading: false,
      errors: {},
      services: [],
      cardColors: _.sortBy(CardColor.colors, 'description'),
      form: {
        id: null,
        description: null,
        monthly_value: 0,
        monthly_balance: 0,
        membership_fee: 0,
        obs: null,
        enable: true,
        card_color: null,
        number_of_members: null,
        benefits: [],
        payment_methods: []
      }
    };
  },

  computed: {
    ...mapGetters({
      paymentMethods: 'settings/paymentMethods'
    }),

    benefits() {
      return this.form.benefits.filter(b => !b._destroy);
    },

    persisted() {
      return this.form.id != null;
    },

    sectionName() {
      return this.persisted ? `Editar Plano - ${this.form.id}` : 'Novo Plano';
    },

    anyError() {
      return !_.isEmpty(this.errors);
    }
  },

  mounted() {
    this.init();

    $('#plan-form-payment-methods').dropdown();
  },

  methods: {
    init() {
      if (this.$route.params.id) {
        this.fetch(this.$route.params.id);
      }

      this.getServices(this.$route.params.id);
    },

    getServices() {
      this.loading = true;
      const query = {
        all: true,
        q: {
          s: ['description asc']
        }
      };
      Api.services
        .search(query)
        .then(async response => {
          this.services = _.clone(response.data.services);
        })
        .catch(error => {
          this.$toast.show('Erro ao buscar dados de serviços', 'error');
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    errorsTo(key) {
      const errors = _.isEmpty(this.errors[key]) ? [] : this.errors[key];
      return errors.join(', ');
    },

    _setErrors(errors) {
      this.errors = _.clone(errors);
      setTimeout(() => {
        $('.error.field').popup();
      }, 100);
    },

    addBenefit() {
      this.form.benefits.push({
        id: null,
        service_id: null,
        limit: null,
        _destroy: false
      });
    },

    removeBenefit(index) {
      let benefit = this.form.benefits[index];

      if (benefit.id != null) {
        benefit._destroy = true;
        this.$set(this.form.benefits, index, benefit);
      } else {
        this.$delete(this.form.benefits, index);
      }
    },

    openHistory() {
      this.$refs.history.open();
    },

    save() {
      this.loading = true;
      this._setErrors({});

      let data = this.form;
      data.benefits_attributes = data.benefits;

      Api.plans
        .save(data)
        .then(async response => {
          this.$toast.show('Plano salvo com sucesso', 'success');
          const plan = response.data.plan;
          plan.monthly_value = plan.monthly_value || 0;
          plan.monthly_balance = plan.monthly_balance || 0;
          plan.membership_fee = plan.membership_fee || 0;
          this.form = _.clone(plan);
        })
        .catch(error => {
          if (error.response) {
            const errors = error.response.data.errors;
            const baseErrors = errors && errors.base;
            if (baseErrors && baseErrors.length) {
              this.$toast.show(baseErrors.join(', '), 'error');
            } else {
              this.$toast.show('Erro ao salvar plano', 'error');
            }
            this._setErrors(errors);
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    },

    remove() {
      const removeIt = confirm('Remover Plano?');
      if (removeIt) {
        this.loading = true;
        Api.services
          .destroy(this.form.id)
          .then(async () => {
            this.$toast.show('Plano removido com sucesso', 'success');
            this.$router.push({ name: 'plans' });
          })
          .catch(error => {
            if (error.response) {
              const errors = error.response.data.errors;
              const baseErrors = errors && errors.base;
              if (baseErrors && baseErrors.length) {
                this.$toast.show(baseErrors.join(', '), 'error');
              } else {
                this.$toast.show('Erro ao remover plano', 'error');
              }
              this._setErrors(errors);
            } else {
              throw error;
            }
          })
          .finally(() => {
            this.$scrollTop();
            this.loading = false;
          });
      }
    },

    _setPaymentMethod() {
      $('#plan-form-payment-methods').dropdown(
        'set selected',
        this.form.payment_methods
      );
    },

    fetch(id) {
      this.loading = true;
      Api.plans
        .fetch(id)
        .then(async response => {
          const plan = response.data.plan;
          plan.monthly_value = plan.monthly_value || 0;
          plan.monthly_balance = plan.monthly_balance || 0;
          plan.membership_fee = plan.membership_fee || 0;

          this.form = _.clone(plan);
          this._setPaymentMethod();
        })
        .catch(error => {
          if (error.response) {
            this.$toast.show('Erro ao buscar plano', 'error');
            this.$router.push({ name: 'plans' });
          } else {
            throw error;
          }
        })
        .finally(() => {
          this.$scrollTop();
          this.loading = false;
        });
    }
  }
};
</script>
